






























































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Prop } from 'vue-property-decorator';
import Multiselect from 'vue-multiselect';
import debounce from 'debounce';
import Button from '@/components/Button.vue';

@Component({
  components: {
    Multiselect,
    Button,
  },
})
export default class Select extends Vue {
  @Prop(Array) options!: unknown[];
  @Prop(String) placeholder!: string;
  @Prop(String) subtitle!: string;
  @Prop([Object, String, Array]) value!: unknown;
  @Prop(String) label!: string;
  @Prop(String) variant!: string;
  @Prop(String) displayLabel!: string;
  @Prop(Boolean) loading!: boolean;
  @Prop(Boolean) disabled!: boolean;
  @Prop(Boolean) multiple!: boolean;
  @Prop({ type: Boolean, default: true }) internalSearch!: boolean;
  @Prop({ type: Boolean, default: true }) closeOnSelect!: boolean;
  @Prop({ type: Boolean, default: true }) allowEmpty!: boolean;
  @Prop(String) trackBy!: string;
  @Prop(String) emptyMessage!: string;
  @Prop(String) noResultMessage!: string;
  @Prop(String) readonly name!: string;
  @Prop(String) readonly rules!: string;
  @Prop(String) readonly vid!: string;
  @Prop(Object) readonly customErrorMessages: undefined | { [key: string]: string };
  @Prop({ default: '' }) readonly error!: string;

  $refs!: {
    multiselect: HTMLFormElement;
  }

  get inputVal() {
    return this.value;
  }

  set inputVal(val) {
    this.$emit('input', val);
  }

  close() {
    this.$emit('close');
  }

  submitvalue(value: any) {
    if (value === 'apply') {
      this.$emit('action', value);
    } else {
      this.$emit('cancel', value);
    }
    this.$refs.multiselect.$refs.search.blur();
  }

  debounceEmit(query: string) {
    this.$emit('search-change', query);
  }

  toggleUnSelect(value: any) {
    // console.log(' Teste toggleUnSelectLojas value : ', value);
    // this.$emit('action2', value);
    this.$emit('action2', 'unselect');
  }

  asyncFind = debounce(this.debounceEmit, 500);
}
